// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationGiftPath = 'M48.5 8.967a16.381 16.381 0 011.518 1.748c.44-.582.933-1.15 1.482-1.7a14.3 14.3 0 019-4 12 12 0 0112.6 12.6 13.401 13.401 0 01-.476 3.02C78.43 16.597 81.937 11.126 82 11l6 3.8-.096.14c-.638.939-3.931 5.787-9.363 10.06H95v23h-6v35.5c0 6.1-4 10.5-9.5 10.5h-58C15.701 94 11 89.299 11 83.5V48H5V25h16.459c-5.432-4.273-8.725-9.121-9.364-10.06L12 14.8l6-3.8c.063.126 3.584 5.618 9.41 9.66-1.23-4.292-.273-8.996 2.99-12.193 4.9-4.8 13-4.6 18.1.5zm-9.5 3a5.5 5.5 0 00-3.7 1.4c-2.1 2.2-1.8 5.9.6 8.3 2.4 2.4 7.8 3.1 10.4 2.7.4-2.6.4-7.3-2.7-10.4a6.6 6.6 0 00-4.6-2zM18 83.5V48h28.5v39h-25a3.5 3.5 0 01-3.5-3.5zM53.5 87h26c2.3 0 2.5-2.4 2.5-3.5V48H53.5v39zm0-46H88v-9H53.5v9zm-7-9H12v9h34.5v-9zm17.6-10.284c-3.1 3.1-7.8 3.1-10.4 2.7-.4-2.6-.4-7.3 2.7-10.4a7.1 7.1 0 014.4-2 5.8 5.8 0 013.9 1.4 5 5 0 011.4 3.9 6.9 6.9 0 01-2 4.4z';
var IllustrationGift = baseIllustration('IllustrationGift', {
  getPath: () => IllustrationGiftPath
}, 'ColoredIllustrationGift');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationGift;
//# sourceMappingURL=index.js.map